import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

export const AnimationWrapper = (props: { children: ReactNode }) => {
    const { children } = props;
    return (
        <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{
                duration: 0.3,
                ease: [0.25, 0.46, 0.45, 0.94],
            }}>
            {children}
        </motion.div>
    );
};
